<ion-card *ngIf="jobCertList.length > 0">
        <ion-item>
            <ion-label position="floating">Job Certificate</ion-label>
            <ion-select [(ngModel)]="currentCertificate" cancelText="Cancel" okText="Okay!" [compareWith]="compareById" (ionChange)="setCert($event)">
                <ion-select-option [value]="cert"  *ngFor="let cert of jobCertList"  >{{cert.nam}}</ion-select-option>
            </ion-select>
        </ion-item>
</ion-card>
